import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { loadRecommendationsForNews } from '@common/redux/slices/recommendation.slice';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { loadArticle } from "@common/redux/slices/articles.slice";
import { SingleNews } from "@kursk/components/pages/SingleNews/SingleNews";
import { articlePageProps } from "@kursk/utils/entitiesPages";
import { loadFeedbacks } from "@common/redux/slices/feedbacks.slice";

export default function page({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SingleNews />
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params, req }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadArticle({ _id: id })),
    store.dispatch<any>(loadRecommendationsForNews({ _id: id })),
    store.dispatch<any>(loadFeedbacks({ type: 'article', articleId: Number(id) })),
  ]);
  const { article } = store.getState().articleList;
  return articlePageProps(article, req, false, 'news');
});
